/** Matches backend `jobs.certificateKind` — locked bundled PDF + wizard */
export const JOB_CERTIFICATE_KIND_CP17_BREAKDOWN = 'CP17_BREAKDOWN';

/** Synthetic engineer route segment — must match backend LOCKED_CP17_BREAKDOWN_TEMPLATE_ROUTE_ID */
export const LOCKED_CP17_ENGINEER_TEMPLATE_ID = 'locked_cp17_breakdown_v1';
